export const environment = {
  production: false,
  pvtUrl: 'https://dev.check-provider.com/api/pvt',
  baseUrl: 'https://dev.check-provider.com',
  auth: {
    enabled: true,
    url: 'https://dev.check-provider.com/auth/realms/trinetra/protocol/openid-connect',
    clientId: 'pvt-app',
  },
  dateFormat: 'MMMM d, y',
};
